import { OBaseModel } from '@olameter/o-utilities';
import { Audit, History } from 'src/app/proto/generated/inv_api_message_pb';
import { AuditModel } from './audit.model';

export class HistoryModel implements OBaseModel {
  id: string;
  name: string;
  taskName: string;
  userName: string;
  activityType: string;
  activityDetail: string;
  postProcessing: string;
  timeStamp?: Date;
  auditsList: Array<AuditModel>;
  timeZone: string;

  static Mapper(source: History): HistoryModel {
    const destination: HistoryModel = new HistoryModel();
    destination.id = source.getInventoryName();
    destination.name = source.getInventoryName();
    destination.taskName = source.getTaskName();
    destination.userName = source.getUserName();
    destination.activityType = source.getActivityType();
    destination.activityDetail = source.getActivityDetail();
    destination.timeStamp = source.getTimeStamp().toDate();
    destination.auditsList = HistoryModel.MapperAuditList(source.getAuditsList());
    destination.timeZone = source.getTimeZone();
    return destination;
  }

  static MapperAudit(source: Audit): AuditModel {
    const destination: AuditModel = new AuditModel();
    destination.name = source.getHistoryName();
    destination.fieldName = source.getFieldName();
    destination.newValue = source.getNewValue();
    destination.oldValue = source.getOldValue();
    return destination;
  }

  static MapperList(source: History[]): HistoryModel[] {
    const list: HistoryModel[] = [];
    source?.forEach((element) => {
      list.push(HistoryModel.Mapper(element));
    });
    return list;
  }

  static MapperAuditList(source: Audit[]): AuditModel[] {
    const list: AuditModel[] = [];
    source?.forEach((element) => {
      list.push(HistoryModel.MapperAudit(element));
    });
    return list;
  }
}
